"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.replace.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Constants");
var _questionBuilder = require("@pcty/question-builder");
var PctyQuestionBuilderEditConditionalReview = function PctyQuestionBuilderEditConditionalReview(_ref) {
  var currentExpression = _ref.currentExpression,
    questions = _ref.questions;
  var getAnswerLabels = function getAnswerLabels(question, itemIdsOrValues) {
    var triggerAnswers = "";
    var answerLabels = [];

    // ensure we have values to check and that the question is valid
    if (!question || !question.options || !itemIdsOrValues || itemIdsOrValues.length === 0) return "";

    // checkboxes have arrays of items
    if (Array.isArray(itemIdsOrValues)) {
      itemIdsOrValues.forEach(function (itemName) {
        // find the choice object for the itemName
        var choices = question.options.filter(function (x) {
          return x.id === itemName;
        });
        if (choices && choices.length > 0) {
          answerLabels.push(choices[0].value);
        } else {
          answerLabels.push(itemName); // just add the item name if we didn't find it!
        }
      });
    } else {
      // radios and others just have a string
      // find the choice object for the itemName
      var choices = question.options.filter(function (x) {
        return x.id === itemIdsOrValues;
      });
      if (choices && choices.length > 0) {
        answerLabels.push(choices[0].value);
      } else if (itemIdsOrValues.toLowerCase() === 'otheroption') {
        if (question.otherQuestion) {
          answerLabels.push(question.otherQuestion.label || 'Other');
        } else {
          answerLabels.push('Other');
        }
      } else {
        if (question.typeId === _questionBuilder.QUESTION_TYPE.starRating) {
          var label = itemIdsOrValues === "1" ? "1 Star" : "".concat(itemIdsOrValues, " Stars");
          answerLabels.push(label);
        } else if (question.typeId === _questionBuilder.QUESTION_TYPE.ratingScale) {
          var ratingValue = parseInt(itemIdsOrValues);
          if (ratingValue && !isNaN(ratingValue) && question.options.length >= ratingValue) {
            var _label = question.options[ratingValue - 1].value; // ratings are 1-based, not 0-based!
            answerLabels.push(_label);
          }
        }
      }
    }

    // if the answerLabels is empty, we didn't find the answer in the question, so just add the raw value!
    if (answerLabels.length === 0) {
      answerLabels.push(itemIdsOrValues);
    }

    // checkboxes have multiple answers, so join with ','
    triggerAnswers = answerLabels.join(', ');
    return triggerAnswers;
  };
  var getReviewDetailForTriggerClause = function getReviewDetailForTriggerClause(expression, triggerTemplate) {
    var triggerClauses = "";
    if (!expression || expression.length < 3) return null;
    var parts = expression.indexOf(_PctyQuestionBuilder2.CONDITIONAL_OPERATORS.EQUALS) > 0 ? expression.split(_PctyQuestionBuilder2.CONDITIONAL_OPERATORS.EQUALS) : expression.split(_PctyQuestionBuilder2.CONDITIONAL_OPERATORS.NOT_EQUALS);
    if (!parts || parts.length !== 2) return null;

    // get the condition pieces (leftValue '=' rightValue) (question3 = 'item2' or question3 = ['item2','item3'])
    var questionId = parts[0] && parts[0].length > 0 ? parts[0].trim() : "";

    // get the titles for the trigger question
    var question = questions.find(function (x) {
      return x.id === questionId;
    });
    if (!question) return null;
    var questionTitle = (0, _PctyQuestionBuilder.removeHtmlTags)(question.question);

    // check for the NOT operator in the expression (<>)
    var notOperatorText = expression && expression.indexOf(_PctyQuestionBuilder2.CONDITIONAL_OPERATORS.NOT_EQUALS) > -1 ? " not" : "";

    // get the titles for the trigger answers
    var chosenItems = parts[1] && parts[1].length > 1 ? JSON.parse(parts[1]) : undefined;
    if (!chosenItems) return null;
    var triggerAnswers = getAnswerLabels(question, chosenItems);

    // only add the clause if it has a title and answer-set
    if (questionTitle.length > 0 && triggerAnswers.length > 0) {
      var triggerClause = triggerTemplate.replace("[TRIGGER_TITLE]", questionTitle);
      triggerClause = triggerClause.replace("[TRIGGER_NOT_OPERATOR]", notOperatorText);
      triggerClause = triggerClause.replace("[TRIGGER_ANSWERS]", triggerAnswers);
      triggerClauses += triggerClause;
    }
    return triggerClauses;
  };

  /* SAMPLE OUTPUT!
      For question "Which franchise has the better superheroes?", when answer(s) "DC" are chosen,
      AND
      For question "Which franchise has the better superheroes?", when answer(s) "DC2,3432" are chosen,
      THEN
      This Question/Content will appear.
  */
  var getReviewStatements = function getReviewStatements() {
    if (!currentExpression || currentExpression.length <= 0) return null;
    var scrubbedExpression = currentExpression.replace(/\{|\}/ig, '');
    var jsonExpression = scrubbedExpression;
    // json.parse may fail depending on the expression!
    try {
      jsonExpression = JSON.parse(scrubbedExpression);
    } catch (_unused) {}
    var rawClauses = jsonExpression.split(/(\sand\s|\sor\s)/);
    if (!rawClauses || rawClauses.length <= 0 || !rawClauses[0] || rawClauses[0].length <= 0) return null;

    //todo: test with titles and answers that have quotes and dbl quotes
    var triggerTemplate = "<div class='review-details-block'>For question <span class='question-text'>&quot;[TRIGGER_TITLE]&quot;</span>, when answer(s) <span class='question-text'>&quot;[TRIGGER_ANSWERS]&quot;</span> are[TRIGGER_NOT_OPERATOR] chosen,</div>";
    var compoundTemplate = "<div class='review-details-block'><span class='expression_tag'>[COMPOUND_OPERATOR]</span></div>";
    var questionTemplate = "<div class='review-details-block'>This <span class='question-text'>[QUESTION_TITLE]</span> will appear.</div>";
    var triggerClauses = "";

    // loop over all the expression clauses and construct the text
    rawClauses.forEach(function (line) {
      var clause = line.trim();
      // check/add the compound operator if we already looped
      if (triggerClauses.length > 0 && (clause === _PctyQuestionBuilder2.CONDITIONAL_CONJUNCTIONS.AND || clause === _PctyQuestionBuilder2.CONDITIONAL_CONJUNCTIONS.OR)) {
        var connectiveClause = compoundTemplate.replace("[COMPOUND_OPERATOR]", clause.toUpperCase());
        triggerClauses += connectiveClause;
      } else {
        // get the title/answer block and then append it
        var triggerClause = getReviewDetailForTriggerClause(clause, triggerTemplate);
        if (triggerClause && triggerClause.length > 0) triggerClauses += triggerClause;
      }
    });
    if (triggerClauses.length <= 0) return null;

    // add the THEN line
    var thenClause = compoundTemplate.replace("[COMPOUND_OPERATOR]", "THEN");
    // add the title line for this question
    var questionClause = questionTemplate.replace("[QUESTION_TITLE]", "Question/Content");
    var combinedClauses = triggerClauses + thenClause + questionClause;
    return combinedClauses;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: getReviewStatements()
    }
  });
};
PctyQuestionBuilderEditConditionalReview.propTypes = {
  currentExpression: _propTypes.default.string.isRequired,
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    typeId: _propTypes.default.number.isRequired,
    scenario: _propTypes.default.string,
    question: _propTypes.default.string.isRequired,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    })),
    answers: _propTypes.default.arrayOf(_propTypes.default.shape({
      optionId: _propTypes.default.string.isRequired
    })),
    knockout: _propTypes.default.bool,
    hint: _propTypes.default.string,
    correctFeedback: _propTypes.default.string,
    incorrectFeedback: _propTypes.default.string
  }))
};
var _default = exports.default = PctyQuestionBuilderEditConditionalReview;